var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',[_c('h1',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$appSettings.appWelcomeMessage))])])
}
var staticRenderFns = []

export { render, staticRenderFns }